import cmxSDK from '@nackle/cmx-sdk';
import { cmxUrl } from 'endpoints';
import fetch from '../utils/fetch';
const PROJECT_NAME = 'service-awards';

export default function( ) {
    const serviceAwardsCache = undefined;
    const sdk = new cmxSDK( cmxUrl, fetch, serviceAwardsCache );

    return {
        createKey: async function( name, programId ) {
            const key = {
                name,
                metadata: [ {
                    name: 'programId',
                    value: programId
                } ],
                doNotTranslate: true,
                doNotExport: true
            };

            try {
                const response = await sdk.createKeys( PROJECT_NAME, [ key ] );
                if ( response.errors  ) {
                    // since we are only sending 1 key the first error will be the one we want
                    const error = response.errors[ 0 ];
                    // this acts as a check for an existing key since it tries to create the key every time
                    // let the error pass if the key has been created and only throw if its a different error
                    if ( error.code === 'UNAVAILABLE_KEY_NAME' ) {
                        return response;
                    } else {
                        console.warn( 'partial success in cmx - createKey: ', response );
                        throw error;
                    }
                }
                return response;
            } catch ( error ) {
                console.warn( 'Error in cmx service - createKey: ', error );
                throw new Error( `CMX key creation - ${ error ? error.code : 'unknown' }` );
            }
        },

        saveStringByLocaleAndKey: async function( keyName, locale, value ) {
            return await sdk.createStringByKey( PROJECT_NAME, keyName, locale, value );
        },

        getBundle: async function( locale ) {
            return await sdk.getBundle( PROJECT_NAME, locale );
        },
        createKeys: async function ( keys ) {
            return await sdk.createKeys( PROJECT_NAME, keys );
        },
        createStrings: async function ( locale, strings ) {
            return await sdk.createStrings( PROJECT_NAME, locale, strings );
        }
    };
}
